/**
 * UI 테마·브랜딩 공통 primary 색상 프리셋.
 *
 * Tier 기본 primary 색상은 여기 정의된 프리셋 키와 동일한 hex 를 사용한다.
 * docs/06-branding.md §4 — Tier별 primary 기본값 참고.
 */

export interface ColorPresetDef {
  key: string;
  label: string;
  primary: string;
}

export const AX_COLOR_PRESETS: readonly ColorPresetDef[] = [
  { key: 'indigo', label: '인디고', primary: '#4F46E5' },
  { key: 'blue', label: '블루', primary: '#2563EB' },
  { key: 'teal', label: '틸', primary: '#0D9488' },
  { key: 'green', label: '그린', primary: '#16A34A' },
  { key: 'orange', label: '오렌지', primary: '#EA580C' },
  { key: 'rose', label: '로즈', primary: '#E11D48' },
] as const;

/** Tier 1~2 앱 부팅 시 primary 기본 프리셋 (localStorage 미설정 시) */
export const AX_TIER_DEFAULT_COLOR_PRESET = {
  core: 'indigo',
  mes: 'blue',
  erp: 'teal',
} as const;

export type AxTierDefaultColorPresetKey = keyof typeof AX_TIER_DEFAULT_COLOR_PRESET;

export type AxColorPresetKey = (typeof AX_COLOR_PRESETS)[number]['key'];

/** CSS `var(--ax-color-primary, …)` 폴백 — core(indigo) 기준 */
export const AX_COLOR_PRIMARY_FALLBACK = AX_COLOR_PRESETS[0]!.primary;

export function getColorPresetPrimary(key: string): string {
  return AX_COLOR_PRESETS.find((p) => p.key === key)?.primary ?? AX_COLOR_PRIMARY_FALLBACK;
}

export function isColorPresetKey(key: string): key is AxColorPresetKey {
  return AX_COLOR_PRESETS.some((p) => p.key === key);
}
